import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse, LeadDivisionContact} from '../interfaces/home';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LeadDivisionContactService {

  observablesCache: any = {};

  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl + 'LeadDivisionContact/';
  // fetch all LeadDivisionContact in the database
  allLeadDivisionContact(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getLeadDivisionContact(id: any):Observable<CommonResponse>{
    if(this.observablesCache[id]) return this.observablesCache[id]
    else {
      this.observablesCache[id] = this.http.get<CommonResponse>(this.baseUrl +id).pipe(shareReplay()); 
      return this.observablesCache[id];
    }
  }
  postLeadDivisionContact(id, data: any):Observable<CommonResponse>{
    return this.http.post<CommonResponse>(this.baseUrl +'?leadDivisionId=' +id , data);
  }
  deleteLeadDivisionContact(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateLeadDivisionContact(id: any, data: any):Observable<CommonResponse>{
    return this.http.put<CommonResponse>(this.baseUrl +id, data);
  }
}
